import { IEcpStore } from '../../rest/ecp-locator';

export type EcpMapUserLocation = {
  latitude?: number;
  longitude?: number;
};

export const getLatLng = (obj: EcpMapUserLocation | IEcpStore) => {
  const lat = Number(obj.latitude);
  const lng = Number(obj.longitude);
  return { lat, lng };
};
